import { gql } from '@apollo/client';

export const GET_COMPREHENSIVE_REPORT = gql`
  query getAssessmentReport($data: GetAssessmentInput!) {
    getAssessmentReport(data: $data) {
      id
      fallInPast3Months
      numberOfFalls
      fallDescription
      fallInjuries
      amountOfPainExperienced
      visitedHospital
      visitedPlaceType
      visitDate
      allergies
      allergyNote
      conditions
      conditionNote
      dizzy
      dizzinessDetails
      confusion
      daysOfAlcoholUsagePerWeek
      numberOfDrinksPerDay
      bpLyingNum
      bpLyingDenom
      lyingPulse
      lyingPressureCapturedAt
      bpSittingNum
      bpSittingDenom
      sittingPulse
      sittingPressureCapturedAt
      bpStandingNum
      bpStandingDenom
      standingPulse
      standingPressureCapturedAt
      attachment
      disclaimer
      drugs {
        name
        route
        dosage
        direction
        dosageMeasurement
        quantity
        quantityMeasurement
        frequency
        notes
        providerId
        pharmacyId
        providerName
        pharmacyName
        asNeeded
      }
      patient {
        id
        firstName
        lastName
        date
        gender
        primaryPhone
        primaryAddressId
        optionalPatientSiteId
        addresses {
          id
          address1
          address2
          city
          state
          zip
        }
        pharmacies {
          npi
          name
          phone
          fax
          address
          state
          city
          zip
          active
        }
        providers {
          npi
          type
          firstName
          lastName
          phone
          fax
          address
          state
          city
          zip
          active
        }
      }
      alerts {
        criterionAlerts {
          alertId
          createdAt
          status
          recommendations {
            id
            title
            description
            details
            disabled
          }
          history {
            historyId
            createdAt
            updatedBy
            lastAction
            notes
          }
          criterion {
            id
            title
            disabled
            description
          }
          assessmentId
        }
        medispanAlerts {
          medispanAlertId
          createdAt
          status
          type
          assessmentId
          history {
            historyId
            createdAt
            updatedBy
            lastAction
            notes
          }
          drugs {
            name
            value
          }
          description
          messages {
            description
          }
        }
      }
    }
  }
`;
